import { render, staticRenderFns } from "./PageCreateProform.vue?vue&type=template&id=542878f3&"
import script from "./PageCreateProform.vue?vue&type=script&lang=js&"
export * from "./PageCreateProform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports